import { observer } from "mobx-react";
import { observable, computed, action, autorun, toJS } from "mobx";
import { config } from "src/config";
import { authStore } from 'src/modules/auth';

class AssetStore {

    @action 
    public insertAssetWithRelation = async (data: any) => {
        const response: Response = await fetch(
            config.BASE_URL + "/api/asset/insert_asset_with_relation",
            {
                method: "POST",
                body: data
            }
        );
        const result = await response.json();
        return result.body
    }
}

export default new AssetStore();


// WEBPACK FOOTER //
// ./src/modules/asset/assetStore.ts